import { render, staticRenderFns } from "./A3Page.vue?vue&type=template&id=204e858a&"
import script from "./A3Page.vue?vue&type=script&lang=ts&"
export * from "./A3Page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('204e858a')) {
      api.createRecord('204e858a', component.options)
    } else {
      api.reload('204e858a', component.options)
    }
    module.hot.accept("./A3Page.vue?vue&type=template&id=204e858a&", function () {
      api.rerender('204e858a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/A3/A3Page.vue"
export default component.exports